

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { ChatHelper } from '@signing-page/chat/helpers/chat.helper';
import Icon from '@/components/Icon.vue';
import ChatParticipants from '@signing-page/chat/components/ChatParticipants.vue';
import { IUser } from '@/types/User';
import { IRecipient } from '@/types/Recipient';
import { IChatParticipant } from '@signing-page/chat/types/chat-participant';

@Component({
  components: {
    Icon,
    ChatParticipants,
  },
})
export default class ChatHeader extends Vue {
  @Prop() user!: IUser;
  @Prop() recipients!: IRecipient[];
  @Prop() me!: string;

  showParticipants: boolean = false;

  get hasRecipients(): boolean {
    return this.recipients?.length > 0;
  }

  get chatParticipants(): IChatParticipant[] {
    return ChatHelper.getChatParticipants(
      this.user,
      this.recipients,
      this.me,
      this.$t('you').toString()
    );
  }

  get headerText(): string {
    if (!this.chatParticipants) {
      return '';
    }
    const participantList: string = `${this.chatParticipants
      .map((participant: IChatParticipant, index: number) => {
        return `${participant.fullName || participant.email}${ChatHelper.addPunctuationMark(
          index,
          this.chatParticipants.length
        )}`;
      })
      .join(' ')}`;

    return participantList;
  }

  toggleParticpantList() {
    if (!this.hasRecipients) {
      return;
    }
    this.showParticipants = !this.showParticipants;
  }

  handleClose() {
    this.$emit('close');
  }
}
